import useAuth from './auth/useAuth.js';
import CustomButton from './CustomButton.js';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Button, AppBar, Toolbar, Box, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import Account, { AccountService } from './Account';
import Dialog from '@material-ui/core/Dialog';
const useStyles = makeStyles((theme) => ({
    navbar: {
        background: theme.palette.primary.main,
        padding: 0,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    logo: {
        maxHeight: '60px',
        margin: theme.spacing(1)
    },
    fg: {
        flexGrow: "1"
    },
    button: {
        boxShadow: "none",
        color: "#ffffff",
        fontSize: "1.2rem"
    }
}));
const NavMenu = () => {
    const classes = useStyles();
    const auth = useAuth();
    const login = () => { auth.signin(); };
    const logout = () => { auth.signout(); };
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [firstTime, setFirstTime] = useState(false);
    let location = useLocation();
    const [origin, setOrigin] = useState('/');
    const [build, setBuild] = useState(process.env.REACT_APP_BUILD_VERSION);
    useEffect(() => {
        if (location.pathname != "/ip")
        // remember where I was before redirected to login
        setOrigin(location.pathname);

    }, [location]);
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }
    const handleClose = () => {

            setAnchorEl(null);

    };
    const handleAccount = () => {
        console.log(open);
        setOpen(true);
        handleClose();
    };
    const handleAccountClose = (event, reason) => {
      
        // only allow close if it's not first time
        if (!firstTime) {
            setOpen(false);
        }
    };
    useEffect(() => {
        if (auth && auth.user) {
            if (!auth.user.profileVerified) {
                setOpen(true);
                setFirstTime(true);
            }
            else {
                setOpen(false);
                setFirstTime(false);
            }
        }
       
    }, [auth.user])
    return (
        <AppBar className={classes.navbar} position="static" elevation={0}>                    
        <Container maxWidth="lg">
            <Toolbar sx={{ flexWrap: 'wrap' }} disableGutters>
                <Box className={classes.fg}>
                        <Link to="/"><img src={"images/logo_wide_" + build + ".svg"} alt="equal opportunity online" className={classes.logo} /></Link>
                </Box>
               
                    {auth && auth.user ?
                        <nav>
                            <CustomButton className={classes.button} variant="contained" color="primary" aria-label="Open account controls" onClick={handleMenu}>
                                <PersonIcon />&nbsp;{auth.user.givenName.trim() === "" || auth.user.givenName === null ? auth.user.mail : auth.user.givenName}
                            </CustomButton>
                            
                        <Menu
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            id="user-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >           
                            {auth && auth.user && (auth.user.isSuperAdmin || auth.user.isInstitutionSuperAdmin || auth.user.isRefreshAdmin || auth.user.isDataDownloadAdmin || auth.user.isFeedbackAdmin) ? <MenuItem component={Link} to={'/admin'} onClick={handleClose}>Administration</MenuItem>
                                : null}
                        <MenuItem onClick={handleAccount}>My account</MenuItem>
                        <MenuItem onClick={logout}>Logout</MenuItem>                            </Menu>
                        </nav>
                        :
                        <nav>
                            <CustomButton className={classes.button} variant="contained" color="primary" aria-label="Log in" component={Link} to={"/ip?origin=" + origin} >
                                <PersonIcon />&nbsp;Log in
                        </CustomButton>
                        </nav>
                        }
          
                   
         
            </Toolbar>
            </Container>
            {auth && auth.user ? <Account open={open} onClose={handleAccountClose} mustsave={firstTime} /> : null}

    </AppBar>);
}
export default NavMenu;